import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

// @todo: Migrate to 'Skeleton' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Skeleton} from './../../components/Skeleton';

type ColumnConfig = {
  columns: number;
  columnSizes?: string;
};
const TableRow = styled.div<ColumnConfig>`
  border-bottom: 1px solid #f4f4f4;
  display: grid;
  grid-template-columns: ${props =>
    props.columnSizes ? props.columnSizes : `repeat(${props.columns}, 1fr)`};
  grid-column-gap: 16px;
  padding: 9px 18px;
`;

const StyledMimicTable = styled.div`
  background: white;
  border-radius: 4px;
  border: 1px solid #d2d2d2;
  margin-bottom: 40px;
  padding-top: 48.5px;
  overflow: hidden;
`;

const ColumnHeader = styled.div<ColumnConfig>`
  background: #f9f9f9;
  border-bottom: 1px solid #f4f4f4;
  display: grid;
  grid-template-columns: ${props =>
    props.columnSizes ? props.columnSizes : `repeat(${props.columns}, 1fr)`};
  grid-column-gap: 16px;
  line-height: normal;
  padding: 8px 18px;
`;

const ColumnName = styled.div`
  font-size: 13px;
`;

type MimicTableProps = {
  columnNames: string[];
  columnSizes?: string;
  numRows: number;
  renderSkeleton?: (key: string) => JSX.Element;
};
export const MimicTable = ({
  columnNames,
  columnSizes,
  numRows,
  renderSkeleton = (key: string) => <Skeleton key={key} />,
}: MimicTableProps) => {
  return (
    <StyledMimicTable>
      <ColumnHeader columns={columnNames.length} columnSizes={columnSizes}>
        {columnNames.map(name => (
          <ColumnName key={name}>{name}</ColumnName>
        ))}
      </ColumnHeader>
      {Array(numRows)
        .fill({})
        .map((_, i) => {
          return (
            <TableRow
              columns={columnNames.length}
              key={i}
              columnSizes={columnSizes}>
              {columnNames.map((name, j) =>
                renderSkeleton(`${name}-${i}-${j}`)
              )}
            </TableRow>
          );
        })}
    </StyledMimicTable>
  );
};
